import { inherits as _inherits, createSuper as _createSuper, createClass as _createClass, defineProperty as _defineProperty, classCallCheck as _classCallCheck, assertThisInitialized as _assertThisInitialized, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _pt from '../../node_modules/prop-types/index.js';
import React from 'react';
import { getBuilderComponentOptions } from './config.js';
import ContentBase$1 from './base/ContentBase.js';

var _excluded = ["loadable", "renderContent", "renderLoading", "renderError"];
/**
 * A helper to load data and display content
 */

var ContentBuilder = /*#__PURE__*/function (_React$Component) {
  _inherits(ContentBuilder, _React$Component);

  var _super = _createSuper(ContentBuilder);

  function ContentBuilder() {
    var _this;

    _classCallCheck(this, ContentBuilder);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderLoadableContent", function (data, state, events) {
      var _this$props = _this.props,
          loadable = _this$props.loadable,
          renderContent = _this$props.renderContent,
          renderLoading = _this$props.renderLoading,
          renderError = _this$props.renderError;
      var loadableProps = {};

      if (state.loading) {
        if (renderLoading) return renderLoading(state.slowLoading);

        if (renderLoading !== false) {
          loadableProps.loading = true;
          loadableProps.slowLoading = state.slowLoading;
        }
      }

      if (state.error) {
        if (renderError) return renderError(state.error);

        if (renderError !== false) {
          loadableProps.error = state.error;
        }
      }

      var LoadableComponent = loadable || getBuilderComponentOptions().defaultLoadable;
      return /*#__PURE__*/React.createElement(LoadableComponent, loadableProps, renderContent(data, state, events));
    });

    return _this;
  }

  _createClass(ContentBuilder, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props;
      _this$props2.loadable;

      var renderContent = _this$props2.renderContent,
          renderLoading = _this$props2.renderLoading,
          renderError = _this$props2.renderError,
          otherProps = _objectWithoutProperties(_this$props2, _excluded);

      return /*#__PURE__*/React.createElement(ContentBase$1, _extends({}, otherProps, {
        render: function render() {
          return renderLoading === false && renderError === false ? renderContent.apply(void 0, arguments) : _this2.renderLoadableContent.apply(_this2, arguments);
        }
      }));
    }
  }]);

  return ContentBuilder;
}(React.Component);

_defineProperty(ContentBuilder, "propTypes", {
  renderContent: _pt.func.isRequired,
  renderLoading: _pt.oneOfType([_pt.func, _pt.oneOf([false])]),
  renderError: _pt.oneOfType([_pt.func, _pt.oneOf([false])]),
  initialData: _pt.any,
  loadAction: _pt.func,
  loadParams: _pt.any,
  loadTransform: _pt.func,
  loadSlowDelay: _pt.number,
  onLoad: _pt.func,
  onLoaded: _pt.func,
  loadable: _pt.elementType
});

_defineProperty(ContentBuilder, "defaultProps", {
  initialData: {},
  loadTransform: function loadTransform(data) {
    return data;
  },
  loadSlowDelay: 200
});

var ContentBuilder$1 = ContentBuilder;

export { ContentBuilder$1 as default };
